<template>
  <div class="login d-flex justify-center flex-column" width="1224px">
    <div class="login-card rounded d-flex flex-column align-center">
      <div class="login-card-logo bb-1 d-flex justify-space-around align-center">
        <img
          src="../../static/images/logo.svg"
          alt="Empiricus"
        >
      </div>
      <div class="login-card-form">
        <div class="login-card--title">
          <h3>Acesse sua conta</h3>
          <span>Digite abaixo seus dados de acesso</span>
        </div>

        <LoginForm />
      </div>
      <div class="login-card-logo bt-1 d-flex justify-space-around align-center px-4">
        <span
          v-for="(company, index) in companys"
          :key="index">
          <img :src="company.src" :alt="company.alt" />
        </span>
      </div>
    </div>
    <RecaptchaDisclaimer />
  </div>
</template>

<script>
// Components
import LoginForm from '@/components/LoginForm/index.vue'
import RecaptchaDisclaimer from '@/components/RecaptchaDisclaimer/index.vue'

export default {
  components: {
    LoginForm,
    RecaptchaDisclaimer
  },
  data () {
    return {
      companys: [
        { src: '/static/logo/vitreo.svg', alt: 'Vitreo' },
        { src: '/static/logo/moneytimes.svg', alt: 'Moneytimes' },
        { src: '/static/logo/seudinheiro.svg', alt: 'seudinheiro' },
        { src: '/static/logo/realvalor.svg', alt: 'realvalor' },
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
  .login {

    &-card {
      background: var(--white);
      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
      min-width: 808px;
      max-width: 808px;
      width: 100%;
      margin-top: 10%;

      &-form {
        width: 100%;
        padding: 59px 52px
      }

      &-logo {
        height: 100px;
        width: 100%;
      }

      img {
        max-width: 196px;
        padding: 20px;
      }

      &--title {
        width: 100%;

        h3 {
          font-family: var(--dm-sans-regular);

          color: var(--black);
          font-style: normal;
          font-weight: bold;
          font-size: 20.25px;
          line-height: 27px;
          letter-spacing: -0.002em;
        }

        span {
          font-family: var(--dm-sans-regular);
          font-size: 16px;
          line-height: 21px;
          color: var(--black);
        }
      }
    }

    .bb-1 {
      border-bottom: 1px solid var(--grey-day-030);
    }
    .bt-1 {
      border-top: 1px solid var(--grey-day-030);
    }
  }

  @media screen and (max-width: 1377px) {
    .login {
      &-card {
        &-form {
          width: 100%;
          padding: 25px 52px
        }
        &-logo {
          height: 65px;
          width: 100%;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/Login.vue